import { Component, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Menubar } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { filter } from 'rxjs/operators';
import { ContentService } from '../core/content.service';

@Component({
  selector: 'app-site-header',
  imports: [RouterLink, RouterLinkActive, Menubar, Button, Drawer],
  templateUrl: './site-header.html',
  styleUrl: './site-header.scss'
})
export class SiteHeader {
  readonly content = inject(ContentService);
  private readonly router = inject(Router);

  readonly brand = this.content.brand;
  readonly mobileOpen = signal(false);

  readonly menuItems: MenuItem[] = this.content.nav.map((item) => ({
    label: item.label,
    routerLink: item.route,
    items: item.children?.map((child) => ({
      label: child.label,
      routerLink: child.route
    }))
  }));

  constructor() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.mobileOpen.set(false));
  }
}
